---
fr:
  admin:
    market_prices:
      empty_state: Aucune donnée de prix du marché pour cette sélection.
      errors:
        generic: Impossible de charger les données de prix du marché.
      filters:
        date: Date
        month: Mois
        price_area: Zone de prix
        week_label_placeholder: Sélectionnez une semaine
        week_start: Semaine commençant
        year: Année
      missing_hours:
        caption_clear: Les {total} heures attendues sont disponibles
        caption_missing: "{missing} heures manquantes sur {total} attendues"
        range_display: "{start} – {end}"
        row_caption:
          one: "{count} heure manquante"
          other: "{count} heures manquantes"
        title: Heures manquantes
        value_clear: Tout est bon
        value_missing:
          one: "{count} heure manquante"
          other: "{count} heures manquantes"
        view_day: Voir la journée
      modes:
        day: Jour
        month: Mois
        week: Semaine
      summary:
        coverage_caption: "{present} / {total} heures disponibles"
        coverage_label: Couverture
        missing_caption_unknown: Impossible de déterminer les heures manquantes.
        missing_label: Heures manquantes
        missing_value_unknown: "—"
        price_range: Min {min} · Max {max}
      table:
        elspot_eur: Elspot EUR
        elspot_nok: Elspot NOK
        hour: Heure
        no_value: "–"
        timestamp: Horodatage
      timeline:
        coverage_caption: "{present} sur {total} heures disponibles"
        coverage_value: "{percent}% de couverture"
        gaps_detected: Lacunes détectées
        missing_caption:
          one: "{count} heure manquante"
          other: "{count} heures manquantes"
        prompt_select_day: Sélectionnez un jour sur la frise chronologique pour consulter les heures.
        title: Aperçu de la couverture
      timezone_label: Fuseau horaire · {timezone}
      title: Prix du marché
